/* eslint-disable no-restricted-globals */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import initialState from '../helpers/form-helpers/initial-state';
import FormMessage from '../../common/utility/FormMessage';
import FormBuilder from '../helpers/form-builder';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import * as userAddressActions from '../../../store/actions/user-address-actions';
import * as signInActions from '../../../store/actions/sign-in-form-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formScrollHelpers from '../helpers/form-scroll-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import { findOptionInSelectField } from '../helpers/form-helpers/form-field-helpers';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { formFieldConstants } from '../../utils/constants/form-field-constants';
import { formConstants } from '../../utils/constants/form-constants';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import './user-details.scss';
import ConfirmationModal from '../../common/utility/ConfirmationModal';
import { deepCopyObject } from '../../utils/obj-utils';
import VerifyEmailForm from '../verify-email/VerifyEmailForm';
import ReactModal from '../../../../modal/js/react-modal';
import { domainConstants } from '../../utils/constants/domain-constants';
import {
    getMultilineText
} from '../../../../../general/js/utils';
import Oauth from '../../oauth';
import { IdentityBrokerConfig } from '../../../../../general/js/utils/oauth/constants/identity-broker-config';

class UserDetailsForm extends Component {
    constructor(props) {
        super(props);
        const { formData } = this.props;
        const copyOfFormData = deepCopyObject(formData);
        this.state = {
            ...initialState.userDetailsFormState,
            formData: copyOfFormData,
        };

        this.formMessageRef = React.createRef();
        this.isWomensOpen = formData.ssoDomain === domainConstants.womensOpen;

        this.displayUserDetailsForm = this.displayUserDetailsForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRemoveAccountClick = this.handleRemoveAccountClick.bind(this);
        this.toggleConfirmationModal = this.toggleConfirmationModal.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.handleUserDetailsUpdateSuccess = this.handleUserDetailsUpdateSuccess.bind(this);
        this.handleUserDetailsEmailUpdateSuccess = this.handleUserDetailsEmailUpdateSuccess.bind(this);
        this.submitUserDetailsData = this.submitUserDetailsData.bind(this);
        this.updateFormData = this.updateFormData.bind(this);
        this.handleSSOUpgradeToMemberPlusRedirect = this.handleSSOUpgradeToMemberPlusRedirect.bind(this);
        this.handleSSOUpdateTicketingAccountRedirect = this.handleSSOUpdateTicketingAccountRedirect.bind(this);
        this.handleSSOUpdateAccountRedirect = this.handleSSOUpdateAccountRedirect.bind(this);

        this.formReferences = formScrollHelpers.getFormReferences(formData);
    }

    componentWillReceiveProps(nextProps) {
        const { isSaving } = this.state;
        const { actions } = this.props;
        const {
            loading,
            formData,
            isUserAddressRetrieveSuccessful,
            retrievedUserAddress,
            isUserDetailsUpdatedSuccessful,
            isUserAccountRemovedSuccessful,
            isUserUpdatingEmail
        } = nextProps;

        if (!loading && isUserAddressRetrieveSuccessful) {
            const { county, state } = formData;
            this.setState(formStateHelpers.handleAddressDataChange(retrievedUserAddress, county, state));
        }

        if (!loading && isUserAccountRemovedSuccessful) {
            actions.signOutUser();
            return;
        }

        if (isSaving &&
            !loading &&
            isUserDetailsUpdatedSuccessful) {
            if (isUserUpdatingEmail) {
                this.setState(formStateHelpers.updateSavingState(false), this.handleUserDetailsEmailUpdateSuccess);
                return;
            }

            this.setState(formStateHelpers.updateSavingState(false), this.handleUserDetailsUpdateSuccess);
            return;
        }

        if (isSaving &&
            !loading &&
            !isUserDetailsUpdatedSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false),
                () => {
                    formScrollHelpers.scrollToField(this.formMessageRef);
                });
        }
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.setState(initialState.userDetailsFormState);
        actions.resetUserDetailsFormState();
    }

    componentDidMount() {
        const { formData } = this.state;
        this.setState(formStateHelpers.updateFormFields(formData));
        this.updateFormData();
    }

    updateFormData() {
        const { formData } = this.state;
        const copyOfFormData = deepCopyObject(formData);
        this.setState(formStateHelpers.updateFormData(copyOfFormData));
    }

    handleUserDetailsUpdateSuccess() {
        const { refreshAccountPage } = this.props;
        formScrollHelpers.scrollToField(this.formMessageRef);
        refreshAccountPage(false);
    }

    handleUserDetailsEmailUpdateSuccess() {
        const { isUserUpdatingEmail } = this.state;
        this.setState(formStateHelpers.toggleKey(Object.keys({ isUserUpdatingEmail })[0]));
    }

    handleSubmit(event) {
        event.preventDefault();
        const { formData } = this.state;
        this.setState(formStateHelpers.handleFormValidation(formData), this.handleValidationResult);
    }

    handleSSOUpdateTicketingAccountRedirect() {
        Oauth.updateAccountData(IdentityBrokerConfig.upgradeToTicketingRoute);
    }

    handleSSOUpgradeToMemberPlusRedirect() {
        Oauth.updateAccountData(IdentityBrokerConfig.upgradeToOneClubAdvantageRoute);
    }

    handleSSOUpdateAccountRedirect() {
        Oauth.updateAccountData(IdentityBrokerConfig.updateAccountRoute);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            const { errors } = this.state;
            formScrollHelpers.scrollToInvalidField(errors, this.formReferences);
            return;
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitUserDetailsData);
    }

    submitUserDetailsData() {
        const { actions, accountData } = this.props;
        const { formData } = this.state;
        const {
            callBackUrl,
            actionSuccessText,
            emailChangedConflictMessage
        } = formData;
        const formattedActionSuccessText = actionSuccessText || formMessageConstants.updateUserDetailsSuccessText;

        formScrollHelpers.scrollToField(this.formReferences[formConstants.title]);
        actions.updateUserDetails({
            userDetails: this.state,
            accountData,
            actionSuccessText: formattedActionSuccessText,
            callBackUrl,
            emailChangedConflictMessage
        });
    }

    handleRemoveAccountClick() {
        const { actions } = this.props;
        const { formData } = this.state;
        const { removeAccountCallbackUrl } = formData;
        actions.removeAccount(removeAccountCallbackUrl);
    }

    toggleConfirmationModal() {
        this.setState(formStateHelpers.toggleKey('isConfirmationPopUpOpen'));
    }

    displayVerifyEmailForm() {
        const { isUserUpdatingEmail } = this.state;

        return isUserUpdatingEmail ? <ReactModal isOpen={isUserUpdatingEmail}>
            <VerifyEmailForm isReadOnly={true}></VerifyEmailForm>
        </ReactModal> : null;
    }

    displayUserDetailsForm() {
        const { actions } = this.props;
        const {
            formData, availableCounties, country, availableStates
        } = this.state;
        const { county, mobilePhone, state } = formData;

        const copyOfFormData = deepCopyObject(formData);
        const stateFieldDefaultValue = findOptionInSelectField(copyOfFormData[formConstants.state], this.state[formConstants.state], formFieldConstants.selectFieldOptionsCode);

        copyOfFormData[formConstants.country].defaultValue = this.state[formConstants.country];
        copyOfFormData[formConstants.county].defaultValue = this.state[formConstants.county];
        copyOfFormData[formConstants.state].defaultValue = stateFieldDefaultValue;
        copyOfFormData[formConstants.city].defaultValue = this.state[formConstants.city];
        copyOfFormData[formConstants.addressLine1].defaultValue = this.state[formConstants.addressLine1];
        copyOfFormData[formConstants.addressLine2].defaultValue = this.state[formConstants.addressLine2];
        copyOfFormData[formConstants.addressLine3].defaultValue = this.state[formConstants.addressLine3];
        copyOfFormData[formConstants.postcode].defaultValue = this.state[formConstants.postcode];
        if (this.state[formConstants.dateOfBirth] !== undefined && this.state[formConstants.dateOfBirth] instanceof Date && !isNaN(this.state[formConstants.dateOfBirth])) {
            copyOfFormData[formConstants.dateOfBirth].defaultValue = this.state[formConstants.dateOfBirth];
        }

        if (copyOfFormData[formConstants.offersDetails]) {
            if (copyOfFormData[formConstants.offersDetails][formConstants.refuseOffers]) {
                copyOfFormData[formConstants.offersDetails][formConstants.refuseOffers].isHidden = true;
            }
        }

        return FormBuilder({
            isReadOnly: true,
            formData: copyOfFormData,
            formReferences: this.formReferences,
            countryData: { selectedCountry: country },
            countyData: { availableCounties, label: county ? county.label : formMessageConstants.emptyString },
            stateData: { availableStates, label: state ? state.label : formMessageConstants.emptyString },
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target), this.updateFormData); },
            handleFieldChange: (event) => {
                const eventTarget = event.target;
                const fieldName = eventTarget.name;
                const fieldData = formData[fieldName];
                this.setState(formStateHelpers.handleFieldChangeWithValidation(eventTarget, fieldData), this.updateFormData);
            },
            handleConfirmPasswordChange: (event) => { this.setState(formStateHelpers.handleConfirmPasswordFieldChange(event.target)); },
            handleConfirmEmailChange: (event) => { this.setState(formStateHelpers.handleConfirmEmailFieldChange(event.target)); },
            handleDateChange: (event) => { this.setState(formStateHelpers.handleDateChange(event)); },
            handleMobilePhoneChange: (event) => { this.setState(formStateHelpers.handleMobilePhoneChange(event, mobilePhone.isOptional)); },
            handleCountryChange: (event) => {
                this.setState(formStateHelpers.handleCountryChange(event.target, county, state),
                    () => {
                        actions.resetRetrievedUserAddress();
                    });
            },
            handleFieldValidState: (fieldName) => { const { errors } = this.state; return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors); },
        });
    }

    render() {
        const { isConfirmationPopUpOpen } = this.state;
        const { updateUserDetailsMessages, isUserDetailsUpdatedSuccessful, removeUserAccountWithTicketsMessage } = this.props;
        const { formData } = this.state;
        const {
            formTitle,
            removeAccountInputText,
            removeAccountInputWarning,
            removeAccountModalWarning
        } = formData;
        const removeAccountModalWarningSplit = getMultilineText(removeAccountModalWarning);
        return (
            <Fragment>
                <h1>{formTitle}</h1>
                <div className='category my-details'>
                    <form onSubmit={this.handleSSOUpdateAccountRedirect}>
                        <FormMessage
                            formRef={this.formMessageRef}
                            isSuccessMessage={isUserDetailsUpdatedSuccessful}
                            messages={updateUserDetailsMessages}></FormMessage>
                        {this.displayUserDetailsForm()}
                        {this.displayVerifyEmailForm()}
                        <SSOFormFooter
                            onSubmit={this.handleSSOUpdateAccountRedirect}
                            footerButtonText={formMessageConstants.editUserDetails}
                            isSubmit={false}
                        ></SSOFormFooter>
                    </form>
                    <div className='top'>
                    </div>
                    <div className='bottom'>
                        <a className="remove-account"
                            onClick={this.toggleConfirmationModal}>
                            <span className="ico">
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fal"
                                    data-icon="trash-alt"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    className="icon">
                                    <path fill="white"
                                        d="M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z">
                                    </path>
                                </svg>
                            </span>
                            <span className="text">{removeAccountInputText}</span>
                        </a>
                        <span className='text'>{`${removeAccountInputWarning}`}</span>
                    </div>
                    <ConfirmationModal
                        isOpen={isConfirmationPopUpOpen}
                        inputText={removeAccountInputText}
                        onModalClose={this.toggleConfirmationModal}
                        onApproveClick={this.handleRemoveAccountClick}
                        isApproveButtonDisabled={false}
                        isApproveDanger={true}
                        onCancelClick={this.toggleConfirmationModal}
                        isCancelButtonDisabled={false}>
                        {removeAccountModalWarningSplit.map((text) => {
                            return <h2 key={_.uniqueId()} >{text}</h2>;
                        })}
                        {<div className='remove-account-error'>{removeUserAccountWithTicketsMessage}</div>}
                    </ConfirmationModal>
                </div >
            </Fragment >
        );
    }
}

UserDetailsForm.propTypes = {
    formData: PropTypes.object.isRequired,
    accountData: PropTypes.object.isRequired,
    refreshAccountPage: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        isUserDetailsUpdatedSuccessful: state.userAccount.isUserDetailsUpdatedSuccessful,
        isUserAccountRemovedSuccessful: state.userAccount.isUserAccountRemovedSuccessful,
        updateUserDetailsMessages: state.userAccount.updateUserDetailsMessages,
        removeUserAccountWithTicketsMessage: state.userAccount.removeUserAccountWithTicketsMessage,
        isUserAddressRetrieveSuccessful: state.userAddressSearchData.isUserAddressRetrieveSuccessful,
        retrieveAddressMessages: state.userAddressSearchData.retrieveAddressMessages,
        retrievedUserAddress: state.userAddressSearchData.retrievedUserAddress,
        isUserUpdatingEmail: state.userAccount.isUserUpdatingEmail
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            updateUserDetails: bindActionCreators(userAccountActions.updateUserDetails, dispatch),
            removeAccount: bindActionCreators(userAccountActions.removeAccount, dispatch),
            signOutUser: bindActionCreators(signInActions.signOutUser, dispatch),
            resetUserDetailsFormState: bindActionCreators(userAccountActions.resetUserDetailsFormState, dispatch),
            resetRetrievedUserAddress: bindActionCreators(userAddressActions.resetRetrievedUserAddress, dispatch),
            displayVerifyUserEmail: bindActionCreators(userAccountActions.displayVerifyUserEmail, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserDetailsForm);
